import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import jQuery from 'jquery';
import React from 'react';
import { Provider } from 'react-redux';
// Import all the LEGACY CSS compiled from the old SCSS files.
import { ThemeProvider } from '@sba/design-system';
import 'font-awesome/css/font-awesome.css';
import '../../stylesheets/legacy.css';
import AppsListView from '../apps_list/AppsListView';
// Make font families available
import '../../design_system/design-tokens/css/fonts.css';
import '../../design_system/design-tokens/css/tokens.css';
import AppsListLayout from '../apps_list/AppsListLayout';
import AppsListUnauthorizedView from '../apps_list/AppsListUnauthorizedView';
import UnsupportedBrowserGuard from '../browser_block/UnsupportedBrowserGuard';
import { createAppProjectEditorStore } from './store';
import ErrorBoundary from './ui/ErrorBoundary';

(window as any).jQuery = jQuery;
(window as any).$ = jQuery;

const store = createAppProjectEditorStore();

const queryClient = new QueryClient();
export default function AppListing() {
  return (
    <Provider store={store}>
      <UnsupportedBrowserGuard>
        <ThemeProvider theme="sap_horizon">
          <QueryClientProvider client={queryClient}>
            <AppsListLayout>
              <ErrorBoundary message={<AppsListUnauthorizedView />}>
                <AppsListView />
              </ErrorBoundary>
            </AppsListLayout>
          </QueryClientProvider>
        </ThemeProvider>
      </UnsupportedBrowserGuard>
    </Provider>
  );
}
